export enum FullStoryCustomEvents {
  CredentialBuilder = 'CredentialBuilder',
}

export enum CredBuilderLibraryEvents {
  AddedToLibrary = 'AddedToLibrary',
  RemovedFromLibrary = 'RemovedFromLibrary',
  CredentialCloned = 'CredentialCloned',
  CredentialDownloadPresentation = 'CredentialDownloadPresentation',
  ViewCredential = 'ViewCredential',
  AddedToMarquee = 'AddedToMarquee',
  RemovedFromMarquee = 'RemovedFromMarquee',
}